export default __webpack_public_path__ + "static/media/dots.0d7e0b8e.svg";